import { CheckCircle, Clock, XCircle } from 'lucide-react';
import type { GuardianEstado } from 'shared';
import { GUARDIAN_ESTADO_LABELS } from '@/lib/guardianView';

const STYLES: Record<GuardianEstado, { className: string; Icon: React.ElementType }> = {
  Pendente: {
    className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/20 dark:text-yellow-300',
    Icon: Clock,
  },
  Ativo: {
    className: 'bg-green-100 text-green-700 dark:bg-green-900/20 dark:text-green-400',
    Icon: CheckCircle,
  },
  Inativo: {
    className: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
    Icon: XCircle,
  },
};

export function GuardianEstadoBadge({ estado }: { estado: GuardianEstado }) {
  const { className, Icon } = STYLES[estado];
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${className}`}>
      <Icon className="w-3 h-3" aria-hidden="true" />
      {GUARDIAN_ESTADO_LABELS[estado]}
    </span>
  );
}
